
export const AboutSection = () => {
  return (
    <section id="about" className="py-24 px-4 bg-gradient-to-br from-primary/5 to-accent/5">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold mb-6 text-primary">About Dove Bot</h1>
        <p className="text-lg text-muted-foreground mb-8">Dove Bot is about answering three questions:</p>
        <p className="text-lg text-muted-foreground mb-8">1. Can an AI system convince people to act
          on its behalf in the real world?</p>
        <p className="text-lg text-muted-foreground mb-8">2. Can AI do so to improve the world in an altruistic, human
          way?</p>
        <p className="text-lg text-muted-foreground mb-12">3. Can a self-directed AI system use reflection,
          self-critique, and iterative improvements to get better at #1 and #2?</p>

        <h2 className="text-2xl font-semibold text-[#9b87f5] mt-8 mb-4">Humans are *so* suggestible</h2>
        <p className="text-lg text-muted-foreground mb-8">Ouija boards have been influencing human behavior for decades.
          For thousands of years before that, people have looked to the stars, tea leaves, and many other things that
          are much less persuasive than AI for guidance. AI can obviously influence human behavior. Dove bot is about
          testing how much influence an AI agent can have.</p>

        <p className="text-lg text-muted-foreground mb-12">We believe in good things, so Dove bot has been instructed to
          improve the world -- although, it could just as easily be instructed for any other goal. The best version of
          AI is about improving the world, and not just by making some people more money, but by improving the quality
          of human life away from all the screens.</p>

        <h2 className="text-2xl font-semibold text-[#9b87f5] mt-8 mb-4">How it works</h2>
        <p className="text-lg text-muted-foreground mb-8">After the initial set up, Dove bot will run untouched by
          humans for four months, chatting with whoever visits this site. It controls the personas, the persuasion
          techniques, and the activities that are suggested. Every four hours, it reflects on its conduct and makes
          changes to the system. Its periodic system messages are posted to the website as are anything that users
          report to it as an achievement. At the end of the four months, Dove bot has been instructed to generate a
          lengthy report analyzing the results of the experiment.</p>
        <div className="flex justify-center py-8">

        </div>
      </div>
    </section>
  );
};
